<template>
  <component
    :is="tag"
    v-bind="componentAttrs"
    :class="classes"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "BaseForm",
  inheritAttrs: false,

  props: {
    tag: { type: String, default: "form" },
    inline: { type: Boolean, default: false },
    novalidate: { type: Boolean, default: false },
    validated: { type: Boolean, default: false },
  },

  computed: {
    classes() {
      const cls = [];
      if (this.inline) cls.push("form-inline");
      if (this.validated) cls.push("was-validated");
      return cls;
    },

    componentAttrs() {
      const attrs = { ...this.$attrs };
      if (this.novalidate) attrs.novalidate = true;
      return attrs;
    },
  },
};
</script>
